/* eslint-disable eqeqeq */
/* eslint-disable no-console */
import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Checkbox } from "antd";
import CustomInput from "../../../Core/Components/CustomInput";
import useSearch from "../../../Core/hooks/useSearch";
import Button from "../../../Core/Components/CustomButton";
import CloseIcon from "../../../Common/Svgs/CloseIcon";
import getBatteryStatus from "../../../Utils/getBatteryStatus";
import BatteryPercentageStatus from "../../Battery/phase3/BatteryPercentageStatus";
import { BatteryEmptyState } from "../../Trips/CreateTrip/EmptyState";
import { BatterySecondaryIcon } from "../../../Common/Svgs/BatteryIcon";
import ChargerIcon from "../../../Common/Svgs/ChargerIcon";
import { updateSession } from "../../../Redux/Slices/sessions.slice";
import { client } from "../../../Utils/axiosClient";

const Step3 = ({ watch, sessionBatteries, setSessionBatteries }) => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const { currentSession } = useSelector((state) => state.sessions);
  // const { allBatteries } = useSelector((state) => state.batteries);

  const selectedHubId = watch("hubId");
  const activityDate = watch("activityDate");
  const activityType = watch("activityId");
  const estimatedArea = watch("area");

  const [focus, setFocus] = useState(false);
  const [batteriesInSystem, setBatteriesInSystem] = useState([]);
  const [required, setRequired] = useState({
    batteries: 3,
    energy: 9,
  });

  const { filteredData, search, setSearch } = useSearch(batteriesInSystem, [
    "value",
  ]);

  // find the batteries currently in hub station
  // const getBatteries = useCallback(() => {
  //   let batteryStatusToCheck = [];

  //   // if creating a new session and start date = current date, return only hub station batteries
  //   if (dayjs(activityDate).isSame(dayjs(), "day")) {
  //     batteryStatusToCheck = [BATTERY_STATUS.HUB_STATION];
  //   }
  //   // if session date = future date, return all the batteries
  //   else {
  //     batteryStatusToCheck = [
  //       BATTERY_STATUS.ON_A_TRIP,
  //       BATTERY_STATUS.DISPATCHED,
  //       BATTERY_STATUS.HUB_STATION,
  //       BATTERY_STATUS.IN_TRANSIT,
  //       BATTERY_STATUS.IN_SESSION,
  //     ];
  //   }

  //   const hubStationBatteries = allBatteries
  //     .filter(
  //       (item) =>
  //         batteryStatusToCheck.includes(+item.status) &&
  //         item.currentHubId == selectedHubId,
  //     )
  //     .map((battery) => ({
  //       ...battery,
  //       id: battery.id,
  //       value: battery.registrationNo,
  //     }));

  //   setBatteriesInSystem(hubStationBatteries);
  // }, [allBatteries, activityDate, selectedHubId]);

  const getBatteries = useCallback(async () => {
    try {
      dispatch(updateSession({ key: "loading", value: true }));

      const params = {
        hubId: selectedHubId,
        activityDate,
        activityType,
        estimatedArea,
      };

      const response = await client.get(
        `${process.env.REACT_APP_API_URL}/session/create-session-batteries`,
        {
          params,
        },
      );

      if (response.status === 200) {
        const { requiredBatteries, requiredEnergy, batteries } = response.data;

        setBatteriesInSystem(batteries);
        setRequired({
          batteries: requiredBatteries,
          energy: requiredEnergy,
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(updateSession({ key: "loading", value: false }));
    }
  }, [dispatch, activityDate, selectedHubId, activityType, estimatedArea]);

  const handleSelection = (battery) => {
    const batteries = sessionBatteries;

    const updatedBatteries = batteries.includes(battery.id)
      ? batteries.filter((item) => item !== battery.id)
      : [...batteries, battery.id];

    setSessionBatteries(updatedBatteries);
  };

  const onClearSelection = () => {
    setSessionBatteries([]);
  };

  useEffect(() => {
    getBatteries();
  }, [getBatteries]);

  useEffect(() => {
    if (id) {
      const updatedBatteries = [];

      currentSession?.batteries?.forEach((item) =>
        updatedBatteries.push(item.id),
      );

      setSessionBatteries([...updatedBatteries]);
    }
  }, [id, currentSession.batteries, setSessionBatteries]);

  return (
    <div className="w-full h-full bg-background-white p-6">
      {batteriesInSystem.length === 0 ? (
        <BatteryEmptyState />
      ) : (
        <div className="w-full h-full">
          <div className="w-full mb-4 px-4 py-2 flex items-center justify-between rounded-lg bg-[#FDE8A8]">
            <p className="font-poppins text-xs font-medium capitalize">
              Recommended Number of Batteries
            </p>

            <div className="flex items-center gap-x-2">
              <div className="flex items-center gap-x-2">
                <BatterySecondaryIcon size={16} />
                <p className="font-aileron text-10 font-semibold">
                  {required?.batteries} Batteries
                </p>
              </div>

              <div className="w-[1px] h-4 bg-yellow" />

              <div className="flex items-center gap-x-2">
                <ChargerIcon size={16} />
                <p className="font-aileron text-10 font-semibold">
                  {required?.energy} kWh
                </p>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-x-3">
            <CustomInput
              intent="searchHome"
              prefix={
                <img src="/assets/icons/search.svg" alt="" className="mr-2" />
              }
              value={search}
              focus={focus}
              border={search.length > 0 ? "success" : "none"}
              placeholderText="filterSelected"
              placeholder="Search Battery ID"
              onChange={(e) => setSearch(e.target.value)}
              suffix={
                search.length > 0 ? (
                  <CloseIcon
                    className="w-4 h-4 cursor-pointer stroke-dark-grey-text"
                    onClick={() => {
                      setSearch("");
                      setFocus(false);
                    }}
                  />
                ) : null
              }
            />
            <Button
              size="primary"
              width="generateUser"
              colors="grey"
              onClick={onClearSelection}
            >
              Clear Selection
            </Button>
          </div>

          <div className="mt-2 h-[calc(100vh-72px-54px-90px-24px-42px-24px)] overflow-y-scroll">
            {filteredData.map((battery) => {
              const selected = sessionBatteries.includes(+battery.id);

              return (
                <div
                  className={`flex justify-between h-10 px-6 border-b cursor-pointer hover:bg-primary-20 border-light-grey 
                  ${selected ? "bg-primary-20" : ""}`}
                  key={battery.id}
                  onClick={() => handleSelection(battery)}
                >
                  <div className="flex items-center gap-x-3">
                    <Checkbox checked={selected} />
                    <p className="text-xs font-semibold text-black capitalize font-aileron">
                      {battery.value}
                    </p>
                  </div>

                  <div className="flex items-center gap-x-12">
                    <div className="w-[112px] flex justify-end">
                      {getBatteryStatus(battery.status)}
                    </div>

                    <div className="w-[52px]">
                      <BatteryPercentageStatus
                        detail={battery}
                        showChargingStatus={false}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};
export default Step3;
